"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
export default function BenefitsTabs(props) {
    var _useState = _sliced_to_array(useState(props.tabs[0]), 2), selectedTab = _useState[0], setSelectedTab = _useState[1];
    var _useState1 = _sliced_to_array(useState(350), 2), maxHeight = _useState1[0], setMaxHeight = _useState1[1];
    var mainRef = useRef(null);
    var _useState2 = _sliced_to_array(useState(false), 2), isBrowser = _useState2[0], setIsBrowser = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), isDesktop = _useState3[0], setIsDesktop = _useState3[1];
    useEffect(function() {
        setIsBrowser(true);
        setIsDesktop(window.innerWidth > 1023);
    }, []);
    useEffect(function() {
        var _Math;
        var _mainRef_current;
        var heights = Array.from(((_mainRef_current = mainRef.current) === null || _mainRef_current === void 0 ? void 0 : _mainRef_current.querySelectorAll(".tab-body")) || []).map(function(el) {
            return el.getBoundingClientRect().height;
        });
        setMaxHeight((_Math = Math).max.apply(_Math, _to_consumable_array(heights)));
    }, [
        selectedTab
    ]);
    var scrollToContent = function() {
        if (mainRef.current && isBrowser && !isDesktop) {
            var yOffset = -75;
            var y = mainRef.current.getBoundingClientRect().top + window.scrollY + yOffset;
            window.scrollTo({
                top: y,
                behavior: "smooth"
            });
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-14 pb-6 relative pt-11 md:pt-20 overflow-hidden bg-gray-30 white-triangle-top"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-10 md:mb-14 lg:mb-16"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "mx-auto mb-2.5 text-center max-w-xs md:max-w-md lg:max-w-lg block text-2xl md:text-3xl lg:text-4xl"
    }, props.heading), props.subheading ? /*#__PURE__*/ React.createElement("p", {
        className: "mb-8 lg:text-lg text-gray-200 text-center"
    }, props.subheading) : null), /*#__PURE__*/ React.createElement("div", {
        className: "relative z-20 flex flex-col lg:flex-row items-center lg:gap-x-4 pb-8 lg:pb-14"
    }, /*#__PURE__*/ React.createElement("nav", {
        className: "w-full lg:w-[45%] relative"
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "flex md:grid md:grid-cols-2 md:gap-x-10 lg:block w-full pb-[84px] md:pb-0"
    }, props.tabs.map(function(tab) {
        /*#__PURE__*/ return React.createElement("li", {
            key: tab === null || tab === void 0 ? void 0 : tab.id,
            onClick: function() {
                setSelectedTab(tab);
                scrollToContent();
            },
            className: clsx("w-full items-start my-1 first:md:mt-0 md:mb-3 md:relative top-px cursor-pointer hover:text-gray-600 md:border-b-4 font-heading flex text-lg transition-all flex-1", {
                "text-gray-600 md:border-b-yellow-500": tab === selectedTab,
                "bg-transparent text-gray-300 md:border-b-gray-400": tab !== selectedTab
            })
        }, /*#__PURE__*/ React.createElement("button", {
            className: "text-center md:flex md:text-left font-medium w-full py-4 focus focus-visible:-outline-offset-4 focus-visible:outline-black"
        }, /*#__PURE__*/ React.createElement("img", {
            height: "40",
            src: "".concat(tab === null || tab === void 0 ? void 0 : tab.iconUrl),
            alt: "".concat(tab === null || tab === void 0 ? void 0 : tab.title),
            loading: "lazy",
            className: clsx("max-h-[30px] max-w-[75px] md:mr-5 mb-3.5 max-[767px]:mx-auto", {
                "opacity-50 grayscale": tab !== selectedTab
            })
        }), /*#__PURE__*/ React.createElement("span", {
            className: clsx("absolute top-[84px] left-0 w-full md:static", {
                "knime-hidden md:block": tab !== selectedTab
            })
        }, tab === null || tab === void 0 ? void 0 : tab.description)));
    }))), /*#__PURE__*/ React.createElement("main", {
        className: "lg:w-[55%] order-first lg:order-last",
        ref: mainRef,
        style: {
            minHeight: "".concat(maxHeight, "px")
        }
    }, /*#__PURE__*/ React.createElement(AnimatePresence, {
        mode: "wait"
    }, /*#__PURE__*/ React.createElement(motion.div, {
        key: selectedTab ? selectedTab.title : "empty",
        initial: {
            y: 10,
            opacity: 0
        },
        animate: {
            y: 0,
            opacity: 1
        },
        exit: {
            y: -10,
            opacity: 0
        },
        transition: {
            duration: 0.2
        },
        className: "h-full tab-body min-h-full"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h3", {
        className: "text-center text-lg md:text-2xl lg:text-4xl"
    }, selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.title), /*#__PURE__*/ React.createElement("div", {
        className: "md:max-w-[480px] lg:max-w-full"
    }, /*#__PURE__*/ React.createElement("img", {
        height: "36",
        className: "max-w-full",
        src: "".concat(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.image),
        alt: "",
        loading: "lazy"
    }))))))), /*#__PURE__*/ React.createElement(SvgBg, null)));
}
function SvgBg() {
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "484px",
        height: "178px",
        viewBox: "0 0 484 178",
        version: "1.1",
        className: "absolute bottom-20 -right-16 hidden lg:block"
    }, /*#__PURE__*/ React.createElement("title", null, "Bit Cluster/Light Gray"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Persona-Page-Desktop:-Data-Experts",
        transform: "translate(-956.000000, -1287.000000)",
        fill: "#F0F2F2"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/User-Benefits",
        transform: "translate(0.000000, 500.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Bit-Cluster/Light-Gray",
        transform: "translate(956.000000, 787.000000)"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(457.000000, 73.000000) rotate(-360.000000) translate(-457.000000, -73.000000) ",
        x: "448",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(393.000000, 73.000000) rotate(-360.000000) translate(-393.000000, -73.000000) ",
        x: "384",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(329.000000, 73.000000) rotate(-360.000000) translate(-329.000000, -73.000000) ",
        x: "320",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(265.000000, 73.000000) rotate(-360.000000) translate(-265.000000, -73.000000) ",
        x: "256",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(169.000000, 73.000000) rotate(-360.000000) translate(-169.000000, -73.000000) ",
        x: "160",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(105.000000, 73.000000) rotate(-360.000000) translate(-105.000000, -73.000000) ",
        x: "96",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(73.000000, 73.000000) rotate(-360.000000) translate(-73.000000, -73.000000) ",
        x: "64",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(41.000000, 73.000000) rotate(-360.000000) translate(-41.000000, -73.000000) ",
        x: "32",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(457.000000, 105.000000) rotate(-360.000000) translate(-457.000000, -105.000000) ",
        x: "448",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(425.000000, 105.000000) rotate(-360.000000) translate(-425.000000, -105.000000) ",
        x: "416",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(361.000000, 105.000000) rotate(-360.000000) translate(-361.000000, -105.000000) ",
        x: "352",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(297.000000, 105.000000) rotate(-360.000000) translate(-297.000000, -105.000000) ",
        x: "288",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(201.000000, 105.000000) rotate(-360.000000) translate(-201.000000, -105.000000) ",
        x: "192",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(169.000000, 105.000000) rotate(-360.000000) translate(-169.000000, -105.000000) ",
        x: "160",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(137.000000, 105.000000) rotate(-360.000000) translate(-137.000000, -105.000000) ",
        x: "128",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(73.000000, 105.000000) rotate(-360.000000) translate(-73.000000, -105.000000) ",
        x: "64",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(521.000000, 137.000000) rotate(-360.000000) translate(-521.000000, -137.000000) ",
        x: "512",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(489.000000, 137.000000) rotate(-360.000000) translate(-489.000000, -137.000000) ",
        x: "480",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(425.000000, 137.000000) rotate(-360.000000) translate(-425.000000, -137.000000) ",
        x: "416",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(329.000000, 137.000000) rotate(-360.000000) translate(-329.000000, -137.000000) ",
        x: "320",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(297.000000, 137.000000) rotate(-360.000000) translate(-297.000000, -137.000000) ",
        x: "288",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(201.000000, 137.000000) rotate(-360.000000) translate(-201.000000, -137.000000) ",
        x: "192",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(521.000000, 169.000000) rotate(-360.000000) translate(-521.000000, -169.000000) ",
        x: "512",
        y: "160",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(457.000000, 169.000000) rotate(-360.000000) translate(-457.000000, -169.000000) ",
        x: "448",
        y: "160",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(393.000000, 169.000000) rotate(-360.000000) translate(-393.000000, -169.000000) ",
        x: "384",
        y: "160",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(425.000000, 9.000000) rotate(-360.000000) translate(-425.000000, -9.000000) ",
        x: "416",
        y: "2.27373675e-13",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(297.000000, 9.000000) rotate(-360.000000) translate(-297.000000, -9.000000) ",
        x: "288",
        y: "2.27373675e-13",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(265.000000, 9.000000) rotate(-360.000000) translate(-265.000000, -9.000000) ",
        x: "256",
        y: "2.27373675e-13",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(201.000000, 9.000000) rotate(-360.000000) translate(-201.000000, -9.000000) ",
        x: "192",
        y: "2.27373675e-13",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(9.000000, 9.000000) rotate(-360.000000) translate(-9.000000, -9.000000) ",
        x: "-1.13686838e-13",
        y: "1.13686838e-13",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(425.000000, 41.000000) rotate(-360.000000) translate(-425.000000, -41.000000) ",
        x: "416",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(361.000000, 41.000000) rotate(-360.000000) translate(-361.000000, -41.000000) ",
        x: "352",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(265.000000, 41.000000) rotate(-360.000000) translate(-265.000000, -41.000000) ",
        x: "256",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(233.000000, 41.000000) rotate(-360.000000) translate(-233.000000, -41.000000) ",
        x: "224",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(169.000000, 41.000000) rotate(-360.000000) translate(-169.000000, -41.000000) ",
        x: "160",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(137.000000, 41.000000) rotate(-360.000000) translate(-137.000000, -41.000000) ",
        x: "128",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(73.000000, 41.000000) rotate(-360.000000) translate(-73.000000, -41.000000) ",
        x: "64",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(9.000000, 41.000000) rotate(-360.000000) translate(-9.000000, -41.000000) ",
        x: "-1.13686838e-13",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }))))));
}
